import { useTranslation } from 'react-i18next'
import { GlowingIcon } from '../../UI/GlowingIcon'
import styles from './Location.module.scss'
import { LocationProps } from './Location.props'

export default function Location(props: LocationProps) {
	const { t } = useTranslation()
	return (
		<div className={styles.location}>
			<div className={styles.location__registration}>
				<div className={styles.location__gbContainer}>
					<i className={`${styles.location__gb} icon-gb`} />
				</div>
				<div>
					<p className='text-s'>{t('landing.footer.location.p1')}</p>
					<p className={`${styles.location__regnum} text-m`}>16391425</p>
				</div>
			</div>
			<div className={styles.location__address}>
				<i className={styles.location__pos} />
				<GlowingIcon
					name='position'
					className={styles.location__pos}
					blurRadius={8}
				/>
				<div>
					<p className='text-xs'>{t('landing.footer.location.p2')}</p>
					<p className='text-s'>13 Lochaline Street, London, England, W6 9SJ</p>
				</div>
			</div>
			<div className={styles.location__map}>
				<img src='images/ltd.png' alt='Location' />
			</div>
		</div>
	)
}
